module.exports = __webpack_public_path__ + "media/images/logo2-d59bd23d.png";